<template>
  <div class="chat-cards">
    <div
      v-if="data && data.options.image"
      class="images"
    >
      <img
        alt="img"
        :src="data.options.image"
      >
    </div>
    <ul
      v-if="data.options && data.options.links"
      class="chat-link"
    >
      <li
        v-for="item in data.options.links"
        :key="item.url"
      >
        <a @click="callback(item)">{{ item.label }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
    name: "Card",
    props: ["data", "callback",],
    data() {
        return {};
    },
    computed: {
        classMsg() {
            return {
                "chat-splash": this.type === "start",
                "chat-sender": this.type === "request",
                "chat-receiver": this.type === "response",
                "hasOfferLink": this.options && this.options.links,
                "four-side-border": this.options && this.options.buttonurl,
            };
        },
    },
};
</script>

<style lang="scss">
    @import "../../assets/styles/scss/chatbot/commons";

    .chat-cards {
        width: 280px;
        max-width: 80%;
        min-width: 280px;
        margin: 0 20px 0 0;

        @include e('question') {
            background: $bg-gray;
            padding: 15px 18px;
        }

        .images {
            width: 280px;
            max-width: 100%;
            margin: 0;
            border-radius: 25px 25px 0 0;
            overflow: hidden;

            &.has-text-after {
                margin-bottom: 15px;
                border-radius: 25px 25px 0 0;
            }

            img {
                display: block;
                width: 280px;
                height: auto;
            }
        }

        .chat-link {
            border-radius: 0px 0px 25px 5px;
        }
    }
</style>
